var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay",class:{ visible: _vm.isLoaderVisible }},[_c('div',{staticClass:"spin-loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }